var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.links),function(link){return (link.allow)?_c('li',[(_vm.hasUrl(link))?_c('a',{attrs:{"href":link.url}},[_vm._v(_vm._s(link.label))]):[_vm._v(_vm._s(link.label))],_vm._v(" "),(_vm.hasChildren(link))?_c('sitemap-list-item',{attrs:{"links":link.children}}):_vm._e()],2):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }